import React from "react";

import { dateTimeService } from "../../utils";
import { useLocalStorage } from "../use-local-storage/useLocalStorage";
import { DateRenderContext } from "./DateRenderContext";

export enum TimeZone {
    UTC = "UTC",
    LOCAL = "Local"
}

type DateRenderFunction = (date: Date) => string;

const renderDateUtc = (date: Date): string => {
    return `${date.toLocaleDateString(undefined, { timeZone: "UTC" })} UTC`;
};

const renderDateTimeUtc = (date: Date): string => {
    return `${dateTimeService().getDateWithTimezone(date).toLocaleString()} UTC`;
};

const renderDateLocal = (date: Date): string => {
    return date.toLocaleDateString();
};

const renderDateTimeLocal = (date: Date): string => {
    return date.toLocaleString();
};

const TimeZoneToDateRenderFunction: Record<TimeZone, DateRenderFunction> = {
    [TimeZone.UTC]: renderDateUtc,
    [TimeZone.LOCAL]: renderDateLocal
};

const TimeZoneToDateTimeRenderFunction: Record<TimeZone, DateRenderFunction> = {
    [TimeZone.UTC]: renderDateTimeUtc,
    [TimeZone.LOCAL]: renderDateTimeLocal
};

const TimeZoneLocalStorageKey = "timeZone";
export const defaultTimeZone = TimeZone.UTC;

export const DateRenderProvider = (props: React.PropsWithChildren<unknown>): JSX.Element => {
    const [timeZone, setTimeZone] = useLocalStorage<TimeZone>(TimeZoneLocalStorageKey, defaultTimeZone);

    const renderDate = (date: Date): string => TimeZoneToDateRenderFunction[timeZone](date);
    const renderDateTime = (date: Date): string => TimeZoneToDateTimeRenderFunction[timeZone](date);

    return (
        <DateRenderContext.Provider value={{ renderDate, renderDateTime, timeZone, setTimeZone }}>
            {props.children}
        </DateRenderContext.Provider>
    );
};
